import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("radar_token");
    if (!token) { setReady(true); return; }
    api.get("/auth/me")
      .then(({ data }) => { setUser(data.user); setTenant(data.tenant); })
      .catch(() => localStorage.removeItem("radar_token"))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (!data?.token) throw new Error("Não foi possível conectar ao servidor (verifique a configuração do backend).");
    localStorage.setItem("radar_token", data.token);
    setUser(data.user); setTenant(data.tenant);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (!data?.token) throw new Error("Não foi possível conectar ao servidor (verifique a configuração do backend).");
    localStorage.setItem("radar_token", data.token);
    setUser(data.user); setTenant(data.tenant);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("radar_token");
    setUser(null); setTenant(null);
  };

  return (
    <AuthCtx.Provider value={{ user, tenant, ready, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
